document.addEventListener('DOMContentLoaded', function () {
  $(window).on('load', function () {
    setTimeout(function () {
      $('#nosto-main-grid .row.row--gutters.products.ss-targeted,#categorypage-nosto-3 .row.row--gutters.products.ss-targeted').slick({
        centerMode: false,
        centerPadding: '60px',
        slidesToShow: 3,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              centerMode: true,
              centerPadding: '40px',
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              arrows: false,
              centerMode: true,
              speed: 500,
              infinite: true,
              cssEase: 'ease',
              centerPadding: '40px',
              slidesToShow: 2
            }
          }
        ]
      });
    }, 3000);
  });
});